export const rootPath = '/coupon';
export const createPath = `${rootPath}/create`;
export const viewPath = `${rootPath}/view`;

export function getCouponPath(couponId) {
  return `${viewPath}/${couponId}`;
}
